<template>
  <div id="person_group_outer">
    <div>
      <div>
        <div class="per_group_label_1">我的团体</div>
        <div v-if="memberList != null && memberList.length > 0">
          <div class="per_group_item" v-for="(item, index) in memberList">
            <div class="per_item_title">{{item.text}}</div>
            <input class="per_item_button" type="button" value="退出" @click="deleteGroup(item)">
          </div>
        </div>
        <div style="text-align: left;margin-top: 30px;color: #666;font-size: 1rem;" v-else>暂未加入任何团体</div>
      </div>
      <div>
        <div class="per_group_label_1">搜索团体</div>
        <div >
          <group-search style="margin-top: 20px;" @searchItem="searchButtonClicked" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import GroupSearch from "./GroupSearch";
export default {
  name: "PersonalGroup",
  components: {
    GroupSearch
  },
  data() {
    return {
      title: '我的团体',
      groups: [
        {
          id: 11,
          title: '上海篮球协会',
        },
        {
          id: 12,
          title: '上海市是壹球成名信息技术有限公司',
        },
        {
          id: 13,
          title: '北京市阿里巴巴信息技术有限公司',
        },
      ],

      searchList: [
        {
          id: 21,
          title: '上海篮球协会',
        },
        {
          id: 22,
          title: '上海篮球协会',
        },
        {
          id: 23,
          title: '上海篮球协会',
        },
      ]
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    memberList() {
      return this.$store.state.memberTeams;
    }
  },

  mounted() {
    console.log(this.user);
    if (this.memberList == null) {
      this.loadData();
    }
  },
  methods: {
    deleteGroup(item) {
      // 退出
      console.log('---1');
      let teamId = item.id;
      let userId = this.user.id;
      let _this = this;
      let params = {
        teamId,
        userId
      }
      console.log(params);
      this.$store.state.http.ajax.ucTeamsQuit(params, function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.$toast('退出成功！');
          _this.loadData();
          return;
        }

        _this.$toast('退出失败！');
      }, function (data) {
        _this.$toast('退出失败，请重试！');
      });
    },

    // dealWithTeamQuit(teamId) {
    //   if (teamId == null || teamId == '') {
    //     return;
    //   }
    //   let memberList = this.memberList;
    //   if (memberList == null || memberList.length == 0) {
    //     return;
    //   }
    //
    //   let tempList = [];
    //   for (let i = 0; i < memberList.length; i++) {
    //     let item = memberList[i];
    //     if (item.id == teamId) {
    //       continue;
    //     }
    //     tempList.push(item);
    //   }
    //
    //   let user = this.$store.state.user;
    //   user.memberTeams = tempList;
    //   this.$store.commit('setUser', user);
    // },

    searchButtonClicked(data) {
      console.log(data);
      let item = data.item;

      let teamId = item.id;
      let params = {
        teamId,
      };
      console.log(params)
      let _this = this;
      // console.log(id);
      this.$store.state.http.ajax.ucTeamsJoin(params,function (data) {
        console.log(data);
        if (data.code == 0) {
          _this.$toast('已申请加入，请耐心等待');
          _this.loadData();
        } else {
          if ( data.code == 1 ) {
            _this.$toast('您已加入该团体！');
            return
          }
          _this.$toast('请求失败！');
        }
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      })
    },
    loadData() {
      let _this = this;
      this.$store.state.http.ajax.ucTeams(function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          let teamList = data.data;
          _this.$store.commit('setMemberTeams', teamList);
        } else {
          _this.$toast('请求失败！');
        }
      }, function (data) {
        _this.$toast('请求失败，请重试');
      })
    }
  }
}
</script>

<style scoped>

  #person_group_outer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-self: center;
    padding-top: 30px;
    padding-bottom: 30px;
    width: 100%;
    padding-left: 5px;
    padding-right: 5px;
  }

  /*##cbb042 */
  #person_group_outer > div {
    border: solid 1px #cbb042;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 30px;

    /*min-height: 650px;*/
  }



  #person_group_outer > div > div {
    width: 100%;
    max-width: 600px;
    padding-left: 3%;
    padding-right: 3%;
    min-width: 290px;
    padding-bottom: 30px;

  }

  /*#person_group_outer > div > div:first-child {*/
  /*  background-color: yellow;*/
  /*}*/

  /*#person_group_outer > div > div:last-child {*/
  /*  background-color: blue;*/
  /*}*/

  @media screen and (min-width: 800px){
    #person_group_outer > div > div {
      width: 50%;
      max-width: 600px;
    }
    #person_group_outer > div {
      min-height: 300px;
    }
  }

  @media screen and (min-width: 1230px){
    #person_group_outer > div {
      width: 1200px;
    }
  }

  .per_group_label_1 {
    color: #cbb042;
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 30px;
  }

  .per_group_item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
  }

  .per_item_title {
    color: #333;
    border: solid 1px #cbb042;
    border-radius: 4px;
    padding: 5px 10px;
    width: 70%;
    text-align: center;
    min-height: 30px;
    font-size: 1rem;
  }
  .per_item_button {
    margin-left: 5%;
    /*width: 20%;*/
    width: 90px;
    border: none;
    border-radius: 15px;
    font-size: 1rem;
    height: 25px;
    color: white;
    background-color: #cbb042;
  }

  input {
    outline: none;
  }

  input.per_item_title {
    text-align: left;
    text-indent: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalGroup.vue